// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__EDWeJ","requiredSymbol":"Label_requiredSymbol__9LKwz","questionIcon":"Label_questionIcon__pV_3k"};